import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const TooltipContainer = styled.div`
  background: white;
  padding: 10px 12px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: none;
  max-width: 224px;
`

export const TooltipTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 3px;
  line-height: 1.4;
`

export const TooltipInfo = styled.div`
  font-size: 11px;
  color: #666666;
  line-height: 1.4;
`
